import { BUCKEYE_BOT } from "../util/constants";
import { constructBotConfig } from "./bots";

const botConfig = constructBotConfig();

export const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: process.env.REACT_APP_AUTH_IDENTITY_POOL,
      region: process.env.REACT_APP_AUTH_REGION,
      allowGuestAccess: true,
    },
  },
  Interactions: {
    LexV2: {
      [BUCKEYE_BOT]: botConfig,
    },
  },
};
